import { useSelector } from 'react-redux'
import { WizardProvider } from '../../../../shared/WizardContext'
import { STEPS } from '../../../../../store/slices/scheduleTour'
import { selectScheduleTourStep } from '../../../../../store/slices/scheduleTour'
import ScheduleTourModal from './Modal'
import { Listing } from '../../../../../api/gqlaxy/gql/generated/graphql'

export interface ScheduleTourWizardProps {
  listing: Listing
}

export const ScheduleTourWizard = ({ listing }: ScheduleTourWizardProps) => {
  const currentStep = useSelector(selectScheduleTourStep)

  return (
    <WizardProvider steps={STEPS} initialStep={currentStep}>
      <ScheduleTourModal listing={listing} />
    </WizardProvider>
  )
}
